export const statistics = {
  to: "https://governordao.org/statistics",
  title: "Statistics",
};

export const applications = [
  { to: "https://stake.governordao.org/", title: "Stake" },
  { to: "https://mine.governordao.org/", title: "Liquidity Mine" },
];

export const resources = [
  { to: "https://governordao.org/media", title: "Media" },
  { to: "https://forum.gdao.info/", title: "Forum" },
  { to: "https://blog.governordao.org/", title: "News/Updates" },  
  { to: "/", title: "Litepaper" },
  { to: "https://governordao.org/ProofOfConcept/GovernorDAO-PoC-UserGuide.pdf", title: "PoC User Guide" },
  { to: "https://governordao.org/contracts", title: "Contracts" },
  { to: "https://governordao.org/team", title: "Team" },
];

export const social = [
  { to: "https://t.me/GovernorProject", title: "Telegram" },
  { to: "https://discord.gg/5UKw3BC", title: "Discord" },
  { to: "https://twitter.com/Governor_DAO", title: "Twitter" },
];
